import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { getAsset } from '../../../../../../util/assets';

const propTypes = {
  className: PropTypes.string,
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  isDisabled: PropTypes.bool,
  isActive: PropTypes.bool,
  thumbnailUrl: PropTypes.string,
  thumbnailActions: PropTypes.node,
  thumbnailActionsClassName: PropTypes.string,
  isDefaultThumbnail: PropTypes.bool,
  isPictureDay: PropTypes.bool,
  note: PropTypes.string,
};

const ProfilePageCard = ({
  className,
  linkTo,
  onClick,
  icon,
  title,
  subtitle,
  isDisabled,
  isActive,
  thumbnailUrl,
  thumbnailActions,
  thumbnailActionsClassName,
  isDefaultThumbnail,
  isPictureDay,
  note,
}) => {
  const classes = classNames({
    'profile-page-card': true,
    'has-thumbnail': !!thumbnailUrl,
    'is-disabled': isDisabled,
    'is-active': isActive,
    'has-default-thumbnail': isDefaultThumbnail,
    [className]: !!className,
  });

  const thumbnailActionsClasses = classNames({
    'profile-page-card-thumbnail-actions': true,
    [thumbnailActionsClassName]: !!thumbnailActionsClassName,
  });

  const TemplateLink = ({ children }) => (
    <Link
      to={linkTo}
      className="profile-page-card-link"
      onClick={event => {
        if (isDisabled) {
          event.preventDefault();
        }

        onClick?.();
      }}
    >
      {children}
    </Link>
  );

  const thumbnail = (() => {
    if (!thumbnailUrl) {
      return (
        <TemplateLink>
          {!icon && (
            <div className="profile-page-card-cover-null-state">
              <img
                alt="Waldo logo"
                className="m-auto d-flex grayscale-faded"
                width="60px"
                src={getAsset(
                  isPictureDay ? '/waldo-excited.png' : '/waldo-icon.svg',
                )}
              />
              <p>
                {isPictureDay
                  ? 'Join the event to get matched!'
                  : 'No photos here yet'}
              </p>
            </div>
          )}
        </TemplateLink>
      );
    }

    return (
      <TemplateLink>
        <img
          src={thumbnailUrl}
          alt={title}
          className="profile-page-card-cover-img"
        />
      </TemplateLink>
    );
  })();

  return (
    <div className={classes}>
      <figure className="profile-page-card-cover">
        {thumbnail}

        {icon && <span className="profile-page-card-cover-icon">{icon}</span>}

        {thumbnailActions && (
          <div className={thumbnailActionsClasses}>{thumbnailActions}</div>
        )}

        {note && <div className="profile-page-card-thumbnail-note">{note}</div>}
      </figure>

      <div className="profile-page-card-content">
        <TemplateLink>
          <p className="profile-page-card-title">{title}</p>

          {subtitle && (
            <div className="profile-page-card-content-footer">
              {subtitle && (
                <span className="profile-page-card-subtitle">{subtitle}</span>
              )}
            </div>
          )}
        </TemplateLink>
      </div>
    </div>
  );
};

ProfilePageCard.propTypes = propTypes;

export default ProfilePageCard;
